import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'

import numberUtils from 'shared/src/utils/number'
import resourceInfo from 'shared/src/resource/info'
import resourcePrice from 'shared/src/resource/price'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
  },
  smallText: {
    fontSize: '0.8em',
    color: '#999'
  },
  boldText: {
    fontWeight: 'bold',
  },
}))

const TemplateTimeSummary = ({
  template,
  link,
}) => {
  const classes = useStyles()


  const dayRate = resourcePrice({
    resource: link.resource,
  })

  const linkPrice = resourceInfo.linkPrice(link)

  const unitsPerDay = linkPrice > 0 ?
    dayRate.price / linkPrice :
    0

  const baseline = resourceInfo.baseLine(template)
  const totalPerDay = baseline * unitsPerDay
  const templateUnit = resourceInfo.baseUnit(template)

  return (
    
    <div>
      <Typography className={ classes.smallText }>
        { numberUtils.twoDp(totalPerDay) } { templateUnit } / Day
      </Typography>
    </div>
  )
}

export default TemplateTimeSummary

